import {useState} from 'react';
import PropTypes from 'prop-types';
import './MoveFolder.scss';
import Locale from '../util/Locale';
import LoadingIndicator from './LoadingIndicator';

function MoveFolder({title = '', srcFolder = '', dstFolder = '', setShowModal = () => {}, onAction = () => {}}) {
    const [status, setStatus] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const renderFooter = () => {
        if (!status) {
            return (
                <div className="move-footer">
                    <nsemble-button text onClick={() => setShowModal && setShowModal(false)}>
                        {Locale.getText('CLOSE')}
                    </nsemble-button>
                </div>
            );
        }
        return (
            <div className="move-footer">
                <nsemble-button text onClick={() => setShowModal && setShowModal(false)}>
                    {Locale.getText('CANCEL')}
                </nsemble-button>
                <LoadingIndicator isLoading={isLoading}>
                    <nsemble-button
                        key="MOVE"
                        text
                        onClick={async event => {
                            const button = event.currentTarget;
                            setIsLoading(true);
                            button.disabled = true;
                            const result = await onAction();
                            button.disabled = false;
                            if (result) {
                                setShowModal(false);
                            } else {
                                setStatus(result);
                                setIsLoading(false);
                            }
                        }}
                    >
                        {Locale.getText('MOVE_FOLDER')}
                    </nsemble-button>
                </LoadingIndicator>
            </div>
        );
    };

    const renderError = () => {
        return <div className="move-folder-error">{Locale.getText('MOVE_FOLDER_ERROR')}</div>;
    };

    return (
        <div>
            <div id="modal-header">
                <h1>{title}</h1>
            </div>
            <div id="modal-body">
                <div className="move-folder">
                    <div className="move-section">
                        {Locale.getText('MOVE_FOLDER_DESCRIPTION', {
                            source: srcFolder,
                            destination: dstFolder
                        })}
                    </div>
                    {!status && renderError()}
                </div>
            </div>
            <div id="modal-footer">{renderFooter()}</div>
        </div>
    );
}

MoveFolder.propTypes = {
    title: PropTypes.string,
    srcFolder: PropTypes.string,
    dstFolder: PropTypes.string,
    setShowModal: PropTypes.func,
    onAction: PropTypes.func
};

export default MoveFolder;
